import React from 'react';
import WalletPage from './WalletPage';

function WalletPageComponent() {
    return <WalletPage shouldListenForResize />;
}

WalletPageComponent.displayName = 'WalletPage';

export default WalletPageComponent;
